import { Outlet, createFileRoute } from '@tanstack/react-router'
import { workspaceQueryOptions } from '#/api/workspaces'
import { QuestionPageStateProvider } from '#/components/questionnaire/question-page/question-page-state'

export const Route = createFileRoute(
  '/_authed/accounts/$accountId/workspaces/$workspaceId',
)({
  beforeLoad: async ({ context, params }) => {
    const workspace = await context.queryClient.ensureQueryData(
      workspaceQueryOptions(params.accountId, params.workspaceId),
    )
    return { workspace }
  },
  component: WorkspaceLayout,
})

function WorkspaceLayout() {
  // The selected drawer tab lives here so it survives question→question
  // navigation (this layout stays mounted; the question route remounts).
  return (
    <QuestionPageStateProvider>
      <Outlet />
    </QuestionPageStateProvider>
  )
}
